import { Section, Block } from 'components/Shared/Layout';
import { Panorama } from 'components/Panorama';
import styles from './style.scss';
import Icon from 'components/Shared/Icon';
import Image from 'components/Shared/Image';
import { BhImage } from 'models/BhImage';
import { SliderAd as SliderAdModel } from 'models/SliderAd';
import { IMenuItem } from 'models/IMenuItem';
import { rm } from 'utils';
import { CategoryLinks } from 'components/Shared/CategoryLinks';

interface OwnProps {
  header: string;
  sliderAds?: SliderAdModel[];
  categories: IMenuItem[];
  description: string;
  usps?: string[];
  displayName: string;
  categoryImage: BhImage;
}

const CATEGORY_IMAGE_DIAMETER = 180;

interface CategoryInfoProps {
  title: string;
  image?: BhImage;
  description: string;
  usps?: string[];
}
const CategoryInfo = ({ title, image, description, usps }: CategoryInfoProps) => (
  <Section className={styles.info}>
    <h2>{title}</h2>
    <Block className={styles.infoRow}>
      <Block className={styles.description}>
        <p>{description}</p>
        <ul>
          {usps &&
            usps.map(usp => (
              <li key={usp}>
                <Icon icon="icon-checkmark" size="small" />
                {usp}
              </li>
            ))}
        </ul>
      </Block>
      <Image
        appearance="rounded"
        {...image}
        width={CATEGORY_IMAGE_DIAMETER}
        height={CATEGORY_IMAGE_DIAMETER}
        alt={title}
      />
    </Block>
  </Section>
);

const CategoryNavigation = ({
  sliderAds,
  header,
  categories,
  description,
  usps,
  displayName,
  categoryImage
}: OwnProps) => (
  <Section appearance="secondary" className={styles.navigation}>
    <Block appearance="primary" shadow="three" type="nav">
      <h1>{displayName}</h1>
      <CategoryLinks links={categories} className={styles.categoryLinks} />
    </Block>
    {sliderAds ? (
      <Block className={styles.panorama}>
        <Panorama
          sliderAds={sliderAds}
          gotoOfferText={rm('ads_offer_linktext')}
          adAppearance="secondary"
        />
      </Block>
    ) : (
      <CategoryInfo title={header} description={description} usps={usps} image={categoryImage} />
    )}
  </Section>
);

export default CategoryNavigation;
